export const claimTypeOptions = [
  { label: 'Investigation', value: 'investigation' },
  { label: 'Partial damage', value: 'partial_damage' },
  { label: 'Whole damage', value: 'whole_damage' },
  { label: 'Missing item', value: 'missing_item' },
];

export const claimStatusOptions = [
  { label: 'Submitted', value: 'submitted' },
  { label: 'Resubmitted', value: 'resubmitted' },
  { label: 'Action required', value: 'action_required' },
  { label: 'In progress', value: 'in_progress' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Credit note pending', value: 'credit_note_pending' },
  { label: 'Successful', value: 'successful' },
  { label: 'Declined', value: 'declined' },
];
